export const FINAL_VERSE = [
  "Now that you have met me, what will you do?",
  "Will you try me or not? It's all up to you.",
  "I can bring you more misery than words can tell.",
  "Come take my hand — let me lead you to Hell.",
];

function wrapLines(ctx, text, maxWidth) {
  const words = text.split(" ");
  const out = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) { out.push(line); line = w; } else line = test;
  }
  if (line) out.push(line);
  return out;
}

export async function renderCard(format) {
  await document.fonts.ready;
  const W = 1080;
  const H = format === "story" ? 1920 : 1080;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#090A0F";
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#EF4444";
  ctx.fillRect(0, 0, 16, H);
  const logo = new Image();
  logo.src = "/logo-mark.png";
  await logo.decode();
  const lh = format === "story" ? 230 : 180;
  const lw = lh * (logo.width / logo.height);
  const topPad = format === "story" ? 300 : 100;
  ctx.drawImage(logo, (W - lw) / 2, topPad, lw, lh);
  ctx.textAlign = "center";
  ctx.fillStyle = "#EF4444";
  const fs = format === "story" ? 64 : 48;
  ctx.font = `italic 600 ${fs}px "Cormorant Garamond", Georgia, serif`;
  let y = topPad + lh + (format === "story" ? 260 : 150);
  for (const raw of FINAL_VERSE) {
    for (const line of wrapLines(ctx, raw, W - 220)) {
      ctx.fillText(line, W / 2, y);
      y += fs * 1.55;
    }
    y += fs * 0.5;
  }
  ctx.fillStyle = "#F5F2EC";
  ctx.font = '500 34px "Space Grotesk", sans-serif';
  ctx.fillText("@movementbreakthecycle", W / 2, H - 160);
  ctx.fillStyle = "#EF4444";
  ctx.font = '500 26px "JetBrains Mono", monospace';
  ctx.fillText("#NoToMeth · #BreakTheCycle · #SaveLives", W / 2, H - 100);
  return canvas;
}

export function downloadCard(canvas, format) {
  canvas.toBlob((blob) => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `shattered-glass-final-verse-${format}.png`;
    a.click();
    URL.revokeObjectURL(a.href);
  }, "image/png");
}
